import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EmployeePaymentsDto } from "./employee-payments-dto";

export class EmployeePaymentsResponse extends GlobalResponseObject{
    data?: EmployeePaymentsDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: EmployeePaymentsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

